import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProviderTypes } from '@guryou/core';
import { Block, DefaultText, FlexRow, LargeText, RightIcon, SmallText, WorkoutIcon } from '@guryou/html-components';
import { borderDefinition, smallBorderRadius } from '@guryou/html-theme';
import { makeStyles } from '@material-ui/core/styles';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';

const useStyles = makeStyles({
  box: {
    backgroundColor: '#fbfdff',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#e8f0fc', // hover color
      // boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)', // optional for elevation
      transform: 'translateY(-2px)',
    },
  },
});

const ProviderType = ({ type = ProviderTypes.centers, setState, goToStep }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleClick = () => {
    setState({ type });
    goToStep(2);
  };
  return (
    <Block
      className={classes.box}
      xs={12}
      md={6}
      lg={4}
      margin={4}
      border={borderDefinition()}
      borderRadius={smallBorderRadius}
      cursor="pointer"
      boxShadow="0 2px 8px rgba(0, 0, 0, 0.04)"
    >
      <FlexRow>
        <Block xs={10} display="flex" flexDirection="column" justifyContent="start" onClick={() => handleClick()}>
          <Block margin={0} padding={1}>
            {type === ProviderTypes.centers ? <WorkoutIcon /> : <DirectionsRunIcon />}
          </Block>
          <DefaultText fontWeight="800" padding={1}>
            {type === ProviderTypes.centers ? t('GENERAL.centers') : t('GENERAL.professionals')}
          </DefaultText>
          <SmallText padding={1} fontWeight={500}>
            {type === ProviderTypes.centers ? t('RIMINI_REGISTER.centerText') : t('RIMINI_REGISTER.profText')}
          </SmallText>
        </Block>
        <Block xs={2} display="flex" flexDirection="row" alignItems="center" justifyContent="center">
          <RightIcon fontSize="medium" />
        </Block>
      </FlexRow>
    </Block>
  );
};

const ChooseProviderType = ({ setState, goToStep }) => {
  const { t } = useTranslation();
  return (
    <Block display="flex" flexDirection="column" alignItems="center" marginTop={10}>
      <LargeText marginBottom={6} textAlign="center" wordBreak="break-word" overflowWrap="break-word" whiteSpace="normal">
        {t('RIMINI_REGISTER.chooseCategory')}
      </LargeText>
      <ProviderType type={ProviderTypes.centers} setState={setState} goToStep={goToStep} t={t} />
      <ProviderType type={ProviderTypes.professionals} setState={setState} goToStep={goToStep} t={t} />
    </Block>
  );
};

export default ChooseProviderType;
